import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/9_purple/9_purple"
 * Contains 1 texture(s)
 */
export class Desktop9PurpleAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/9_purple/9_purple';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '9_purple.png'
    ] as const;
}
